<template>
  <div class="card bg">
    <h2 class="m-3 text-white"><loading-placeholder width="120px" /></h2>
    <div class="m-3">
      <loading-placeholder width="100%" height="150px" />
    </div>
  </div>
</template>
<script>
import LoadingPlaceholder from './shared/loading-placeholder'
export default {
  name: 'marketing-loading',
  components: { LoadingPlaceholder }
}
</script>
